import { capitalize } from 'lodash-es'

const DEFAULT_TITLE = 'MyPlace4Parts'
const INTEGRATION_ENVS = new Set(['int.staging', 'int.qa', 'int.pro'])
const ENV_IDENTIFIERS = [...INTEGRATION_ENVS, 'staging', 'qa', 'pro']

export function getBrowserTitle(hostname: string): string {
  const envId = ENV_IDENTIFIERS.find((id) => hostname.includes(`.${id}.`))
  if (!envId || INTEGRATION_ENVS.has(envId)) return DEFAULT_TITLE

  const prefix = hostname.split(`.${envId}.`)[0]
  const subdomain = prefix.split('.').find((sub) => sub !== 'www')

  return subdomain ? `${capitalize(subdomain)} ${DEFAULT_TITLE}` : DEFAULT_TITLE
}

export function setBrowserTitle(): void {
  document.title = getBrowserTitle(window.location.hostname)
}
